// ניהול משתמשים — המסך היחיד שפתוח לשותפים בלבד.
//
// חלק נפרד ב-strings/ כמו כל אזור אחר, כדי ששתי עבודות מקבילות לא יתנגשו באותו קובץ.
export default {
  // הקבצים שכותב תוכן שלח (מיגרציה 064) — הצד של המנהל.
  //
  // מפתח עליון משלו ולא תחת `jobs`, כי אותו בלוק מופיע בשלושה מסכים שונים: העבודה,
  // הריטיינר וכרטיס הלקוח. הטבלה נבנתה בעבודת ההרשאות, וכל המסכים האלה קדמו לה — ולכן
  // ההעלאות של הכותב נשמרו ולא נראו בשום מקום.
  workFiles: {
    title: 'קבצים שהועלו',
    // בריטיינר: הקבצים מגיעים לנושאים שתחתיו, לא לריטיינר עצמו.
    retainerTitle: 'קבצים שהועלו לנושאים',
    none: 'לא הועלו קבצים.',
    by: 'מאת',
    // הסימון היחיד שמבדיל את הרשימה הזו מכל רשימת קבצים אחרת: אלה הקבצים היחידים
    // שמגיעים מחוץ למשרד, ולכן "האם מישהו הסתכל" היא שאלה אמיתית.
    unseen: 'חדש',

    // --- ההתראה: הפעמון ו"היום שלי" ---------------------------------------------------
    // הכותרת מנוסחת כאירוע ולא כמשימה: משהו קרה, לא משהו שצריך לעשות עד תאריך.
    alertTitle: 'קבצים חדשים שהועלו',
    // "יענקי העלה קובץ ל־ר עמרם"
    alertLine: (who, job) => `${who} העלה קובץ ל־${job}`,
    alertGo: 'לעבודה',
    // ב"היום שלי" — הכותרת והמצב הריק.
    dayTitle: 'הועלו קבצים',
    dayEmpty: 'לא הועלו קבצים חדשים.',
  },
  // המעטפת של כותב תוכן — לא התפריט הרגיל. הוא רואה מסך אחד, ולכן אין לו סרגל ניווט
  // בכלל: סרגל ריק היה נראה תקול בדיוק כמו סרגל מלא בקישורים חסומים.
  limited: {
    title: 'העלאת קבצים',
    // הרשימה היא בדיוק מה שהוקצה — אין כאן חיפוש ואין ניווט, כי אין לאן לנווט.
    pickJob: 'בחר עבודה',
    // ריק = לא הוקצה דבר. זו לא תקלה, ולכן הניסוח אינו ניסוח של שגיאה.
    nothingGranted: 'עדיין לא הוקצו לך עבודות.',
    standalone: 'עבודות בודדות',
    // ההעלאה עצמה
    file: 'קובץ',
    fileTitle: 'כותרת (לא חובה)',
    upload: 'העלה',
    uploading: 'מעלה…',
    uploaded: (name) => `${name} הועלה.`,
    // מה שכבר נשלח — שלו בלבד, ובלי אפשרות להוריד בחזרה.
    mine: 'מה שהעלית',
    mineNone: 'עדיין לא העלית קבצים לעבודה הזו.',
    sizeKb: (kb) => `${kb} KB`,
  },
  users: {
    nav: 'משתמשים',
    title: 'משתמשים',
    // התפקידים. הניסוח מתאר מה כל אחד רואה ועושה — לא "הרשאות", כי ההבדל האמיתי
    // בין שותף למזכירה אינו מה מוצג אלא למי הכסף מיוחס.
    role: 'תפקיד',
    rolePartner: 'שותף',
    roleSecretary: 'מזכירה',
    roleLimited: 'כותב תוכן',

    // רשימה
    name: 'שם',
    email: 'אימייל',
    status: 'סטטוס',
    active: 'פעיל',
    inactive: 'מושבת',
    color: 'צבע ביומן',
    noUsers: 'אין משתמשים להצגה.',

    // פעולות
    add: 'משתמש חדש',
    addTitle: 'הוספת משתמש',
    editTitle: 'עריכת משתמש',
    password: 'סיסמה',
    passwordNew: 'סיסמה ראשונית',
    passwordHint: 'לפחות 8 תווים.',
    setPassword: 'קביעת סיסמה',
    setPasswordTitle: (name) => `קביעת סיסמה — ${name}`,
    resetPassword: 'איפוס סיסמה',

    deactivate: 'השבתה',
    reactivate: 'הפעלה מחדש',
    deactivateTitle: (name) => `השבתת ${name}`,
    // ההשבתה היא הפעולה הרגילה להוצאת אדם מהמערכת, ולכן חשוב שהמסך יאמר מה היא עושה
    // ומה היא שומרת.
    deactivateBody: 'המשתמש לא יוכל להיכנס יותר, וכל החיבורים הפעילים שלו ינותקו מיד.',
    deactivateConfirm: 'השבת',
    deactivated: (name, n) => `${name} הושבת${n ? `, ו-${n} חיבורים פעילים נותקו` : ''}.`,

    remove: 'מחיקה',
    removeTitle: (name) => `מחיקת ${name}`,
    // המחיקה כמעט תמיד תיכשל, וזה בכוונה — עדיף לומר זאת מראש מאשר להציג שגיאה.
    removeBody: 'המחיקה היא לצמיתות. למי שעזב — עדיף השבתה.',
    removeConfirm: 'מחק לצמיתות',

    // מה אי אפשר לעשות, ולמה — מוצג על השורה עצמה, לפני שמישהו ינסה.
    you: 'זה אתה',

    // --- הקצאות: מה כותב תוכן רואה ---------------------------------------------------
    grants: 'הקצאות',
    grantsTitle: (name) => `מה ${name} רואה`,
    grantsRetainers: 'ריטיינרים',
    grantsJobs: 'עבודות בודדות',
    grantsNone: 'לא הוקצה דבר.',
    // התצוגה המדויקת של מה שהוקצה בפועל, מהשרת — לא חישוב של הדפדפן.
    grantsPreview: 'מה זה מקצה בפועל',
    grantsTopics: (n) => `${n} נושאים`,
    grantsStandalone: 'עבודות בודדות',
    grantsSaved: 'ההקצאות נשמרו.',
  },
};
